const ip = "127.0.0.1";
const port = "8085";

// const ip = "183.182.100.208";
// const port = "8086";

const domain = "https://u-win.la";
// const domain = "http://127.0.0.1:8085";
// export const uniIdLoginUrl =
//   "http://uid.com.la:9998/credentials/sign-in/oauth/consent";
export const uniIdLoginUrl = "https://sso.laoid.net/login";
export const uniCheckStateUrl =
  "https://service.laoid.net/apis/sub-service/check";

// export const loginUrl = "http://" + ip + ":" + port + "/apis/user/login";
// export const registerByOtpUrl =
//   "http://" + ip + ":" + port + "/apis/user/register-by-otp";
// export const registerByOtpConfirmUrl =
//   "http://" + ip + ":" + port + "/apis/user/register-by-otp-confirm";
// export const loginByUniIdUrl =
//   "http://" + ip + ":" + port + "/apis/user/login-by-uniId";
// export const buyTurnUrl = "http://" + ip + ":" + port + "/apis/user/buy-turn";
// export const buyTurnConfirmUrl =
//   "http://" + ip + ":" + port + "/apis/user/buy-turn-confirm";
// export const refreshTokenUrl =
//   "http://" + ip + ":" + port + "/apis/user/refresh-token";
// export const auctionSubmitUrl =
//   "http://" + ip + ":" + port + "/apis/game/auction-submit";
// export const loadInitAuctionUrl =
//   "http://" + ip + ":" + port + "/apis/game/load-init-auction";
// export const loadResultUrl =
//   "http://" + ip + ":" + port + "/apis/result/load-result";
// export const loadHomeDataUrl =
//   "http://" + ip + ":" + port + "/apis/game/load-home-data";
// export const loadMonthlyResultUrl =
//   "http://" + ip + ":" + port + "/apis/result/load-monthly-result";
// export const loadHistoryDataUrl =
//   "http://" + ip + ":" + port + "/apis/history/load-data";
// export const loadAccountInfoUrl =
//   "http://" + ip + ":" + port + "/apis/user/account-info";
// export const loadResultWinnerUrl =
//   "http://" + ip + ":" + port + "/apis/result/load-result-winner";

// PROD
export const loginUrl = domain + "/apis/user/login";
export const registerByOtpUrl = domain + "/apis/user/register-by-otp";
export const registerByUniserviceUrl =
  domain + "/apis/user/register-by-uniservice";

export const registerByOtpConfirmUrl =
  domain + "/apis/user/register-by-otp-confirm";
export const loginByUniIdUrl = domain + "/apis/user/login-by-uniId";
export const buyTurnUrl = domain + "/apis/user/buy-turn";
export const buyTurnConfirmUrl = domain + "/apis/user/buy-turn-confirm";
export const refreshTokenUrl = domain + "/apis/user/refresh-token";
export const auctionSubmitUrl = domain + "/apis/game/auction-submit";
export const loadInitAuctionUrl = domain + "/apis/game/load-init-auction";
export const loadResultUrl = domain + "/apis/result/load-result";
export const loadHomeDataUrl = domain + "/apis/game/load-home-data";
export const loadMonthlyResultUrl = domain + "/apis/result/load-monthly-result";
export const loadHistoryDataUrl = domain + "/apis/history/load-data";
export const loadAccountInfoUrl = domain + "/apis/user/account-info";
export const loadResultWinnerUrl = domain + "/apis/result/load-result-winner";
export const updateUserStateUrl = domain + "/apis/user/update-user-state";
